module.exports = __webpack_public_path__ + "static/media/who-sends-the-man.b37f9865.jpg";